<section>
  <div class="content-2">
    <div class="title-container">
      <h1 class="title">Número de dias letivos</h1>
      <h2 class="subtitle">
        Informe o número de dias letivos por semana em cada etapa/modalidade.
      </h2>
    </div>

    <hr class="division-line" />
    <div class="dropdown-panel panel">
      <app-menu-suspenso
        #menuTooltip="matTooltip"
        [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
        matTooltipPosition="above"
        [opcoes]="[
          {
            rotulo: 'PQR desta funcionalidade',
            icone: 'computer',
            acao: 'pqrDestaFuncionalidade'
          },
          {
            rotulo: 'Restaurar valores com base no PQR',
            icone: 'content_copy',
            acao: 'restaurarValoresComBaseNoPqr'
          },
          {
            rotulo: 'PQR completo em nova aba',
            icone: 'desktop_windows',
            acao: 'pqrCompletoEmNovaAba'
          }
        ]"
        (chamadaDeAcao)="chamarAcao($event)"
      >
        Padrão de qualidade de referência (PQR)
      </app-menu-suspenso>

      <mat-icon
        (mouseenter)="openTooltips()"
        (mouseleave)="closeTooltips()"
        class="info-icon"
        #infoTooltip="matTooltip"
        matTooltip="Informações sobre o PQR"
        matTooltipPosition="left"
      >
        info
      </mat-icon>
    </div>

    <div class="panel">
      <div class="table-wrapper">
        <app-tabela
          [cabecalhos]="[
            { titulo: 'Etapa', tamanho: '50%' },
            { titulo: 'Número de dias letivos (PQR)', tamanho: '50%' },
          ]"
          ngSkipHydration
          class="table-component"
        >
          <ng-container corpo>
            <tr *ngFor="let dados of pqrNumeroDiasLetivosValores">
              <td class="table-cell align-left">{{ dados.etapaEnsino.descricao }}</td>
              <td class="table-cell align-left">
                <input
                  type="number"
                  [(ngModel)]="dados.qntDiasLetivos"
                  (ngModelChange)="atualizarValores()"
                  class="display-input text-green align-center"
                  maxlength="2"
                  appOnlyNumbers
                />
              </td>
            </tr>
          </ng-container>
        </app-tabela>
      </div>
    </div>
  </div>
</section>
